export default "__VITE_ASSET__39ddde68__"